import type { CurrencyOption, ValidCurrency, ValidLocale } from './config';

export const AVAILABLE_LOCALES = ['en', 'pt', 'fr', 'de'] as const;
export const DEFAULT_LOCALE_CODE: ValidLocale = 'en';
export const DEFAULT_CURRENCY_CODE: ValidCurrency = 'eur';

export const DEFAULT_CURRENCY: CurrencyOption = {
  code: DEFAULT_CURRENCY_CODE,
  name: 'Euro',
  symbol: '€',
};
